module.exports = __webpack_public_path__ + "img/culionline.60daba0e.png";